/* @flow */

import * as React from 'react';

import './select-two-line-icon.css';

type Props = {
    icon: React.ComponentType<*>,
    label: string,
    sublabel: string,
};

export function IconAndLabel(props: Props) {
    const {icon, label, sublabel} = props;
    const Icon = icon;

    return (
        <div className='flex align-center'>
            {Icon ? (
                <div styleName='icon-container'>
                    <Icon size={19} />
                </div>
            ) : (
                undefined
            )}
            <div>
                <div styleName='label'>{label}</div>
                <div styleName='sublabel'>{sublabel}</div>
            </div>
        </div>
    );
}
